import { HttpLink } from 'apollo-link-http'
import config from 'config'

export default new HttpLink({
	uri: `${config.AUTH_API_URL}/graphql`,
	useGETForQueries: true,
})
